import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import _ from "lodash";
import {
  clearComponentLoading,
  clearErrors,
  clearPageLoading,
  resetAlert,
  setAlertError,
  setComponentLoading,
  setErrors,
  setPageLoading,
} from "../store/actions";
import { getInspectionStatusPageSetting } from "../api/setting/pageApi";
import { setPageSettings } from "../store/actions/pageActions";
import {
  createGroupTree,
  findNodeByName,
  getSelectOptionsByName,
} from "../utils/group-tree";
import { errorStatusHandle } from "../utils";
import { fetchInspectionStatus } from "../api/status/inspection-apis";
import { getDaysInMonth } from "../utils/datetime-utils";
import { range } from "../utils/array-utils";

export const useInspectionStatusPage = (setParams) => {
  const [groupsList, setGroupsList] = useState({});
  const [groupsChildren, setGroupsChildren] = useState({});
  const [groupTree, setGroupTree] = useState(null);
  const [filterList, setFilterList] = useState({
    1: null,
    2: null,
    3: null,
    4: null,
    5: null,
    template: {value: null, label: "[ALL]"},
    month: "this_month",
  });
  const [filterGroupsOptions, setFilterGroupOptions] = useState({});
  const [templates, setTemplates] = useState([])
  const [templateOptions, setTempalteOptions] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setPageLoading());
    getInspectionStatusPageSetting()
      .then((pageSettings) => {
        dispatch(setPageSettings(pageSettings));
        setGroupsChildren(pageSettings.options.group_and_children);
        let grouplst = {
          1: [],
          2: [],
          3: [],
          4: [],
          5: [],
        };
        Object.entries(pageSettings.options.group_list).forEach((group) => {
          grouplst[group[0]] = group[1].map((v) => {
            return { value: v.id, label: v.name };
          });
        });
        setTemplates(pageSettings.options.templates);
        setGroupsList(grouplst);
        const root = createGroupTree(
          pageSettings.options.group_list,
          pageSettings.options.group_and_children
        );
        setGroupTree(root);
        dispatch(clearPageLoading());
        if (pageSettings.user_setting?.setting) {
          const filterListSetting = pageSettings.user_setting.setting;
          setFilterList(filterListSetting);
          setParams({
            group_1: filterListSetting[1]?.value,
            group_2: filterListSetting[2]?.value,
            group_3: filterListSetting[3]?.value,
            group_4: filterListSetting[4]?.value,
            group_5: filterListSetting[5]?.value,
            month: filterListSetting.month,
            template: filterListSetting.template?.value?? null,
            first: false,
          });
        }
      })
      .catch((e) => {
        dispatch(clearPageLoading());
        errorStatusHandle(e.response);
      });
  }, [dispatch]);

  useEffect(() => {
    if (groupTree) {
      let group2Parent = filterList[1]?.value
        ? findNodeByName(groupTree, filterList[1]?.value, 1)
        : [groupTree];
      let group3Parent = filterList[2]?.value
        ? findNodeByName(groupTree, filterList[2]?.value, 2)
        : group2Parent;
      let group4Parent = filterList[3]?.value
        ? findNodeByName(groupTree, filterList[3]?.value, 3)
        : group3Parent;
      let group5Parent = filterList[4]?.value
        ? findNodeByName(groupTree, filterList[4]?.value, 4)
        : group4Parent;
      const filterOptions = {
        1: getSelectOptionsByName([groupTree], 1, filterList, false),
        2: getSelectOptionsByName(group2Parent, 2, filterList, false),
        3: getSelectOptionsByName(group3Parent, 3, filterList, false),
        4: getSelectOptionsByName(group4Parent, 4, filterList, false),
        5: getSelectOptionsByName(group5Parent, 5, filterList, false),
      };
      setFilterGroupOptions(filterOptions);
      for (let i = 2; i <= 5; i++) {
        if (
          _.some(filterOptions[i], { value: filterList[i]?.value }) === false &&
          filterList[i] !== null
        ) {
          setFilterList({ ...filterList, [i]: null });
        }
      }
    }
  }, [groupTree, filterList]);

  useEffect(() => {
    let availableTemplates = _.filter(templates, (item) => {
      if (filterList[1]?.value && item.group_1?.name && item.group_1?.name !== filterList[1].value) {
        return false;
      }
      if (filterList[2]?.value && item.group_2?.name && item.group_2?.name !== filterList[2].value) {
        return false;
      }
      if (filterList[3]?.value && item.group_3?.name && item.group_3?.name !== filterList[3].value) {
        return false;
      }
      if (filterList[4]?.value && item.group_4?.name && item.group_4?.name !== filterList[4].value) {
        return false;
      }
      if (filterList[5]?.value && item.group_5?.name && item.group_5?.name !== filterList[5].value) {
        return false;
      }
      return true;
    });
    let options = [{ value: null, label: "[ALL]" }];
    if (availableTemplates) {
      availableTemplates.forEach((template) => {
        options.push({value: template.id, label: template.name});
      })
    }
    setTempalteOptions(options);
  }, [filterList, templates])
  return {
    groupsList,
    setGroupsList,
    groupsChildren,
    setGroupsChildren,
    groupTree,
    setGroupTree,
    filterList,
    setFilterList,
    filterGroupsOptions,
    setFilterGroupOptions,
    templateOptions,
  };
};

export const useInspectionStatusData = () => {
  const [inspectionStatus, setInspectionStatus] = useState({});
  const [params, setParams] = useState({
    group_1: "",
    group_2: "",
    group_3: "",
    group_4: "",
    group_5: "",
    template: null,
    month: "this_month",
    first: true,
  });
  const [errors, setErrors] = useState([]);
  const dispatch = useDispatch();
  const today = new Date();
  const dates = getDaysInMonth(
    today.getFullYear(),
    today.getMonth() + 1,
    params.month === "last_month"
  );
  useEffect(() => {
    dispatch(resetAlert());
    setErrors([]);
    // dispatch(setButtonProcessing("btn-mypage-filter"));
    if (params.first !== true) {
    dispatch(setComponentLoading("inspection_status_table"));
    fetchInspectionStatus(params)
      .then((response) => {
        dispatch(resetAlert());
        const inspectionStatusData = response.data;
        if (inspectionStatusData.length === 0) {
          dispatch(setAlertError("承認設定はありません。"));
        }
        setInspectionStatus((inspectionStatus) => {
          inspectionStatusData?.forEach((data, i) => {
            data.machine_status?.forEach((status, idx) => {
              let dailyResult = range(1, dates).map((day, j) => {
                let result = _.filter(status.daily_results, {
                  inspection_day: day,
                });
                if (
                  result.length === 0 &&
                  (j < today.getDate() || params.month === "last_month")
                ) {
                  result = {
                    inspection_day: j + 1,
                    inspection_result: -1,
                    judgment_result: -1,
                    not_inspect: true,
                  };
                  return result;
                }
                return result[result.length - 1];
              });
              inspectionStatusData[i].machine_status[idx].daily_results =
                dailyResult;
            });
          })
          return inspectionStatusData;
        });
        dispatch(clearComponentLoading("inspection_status_table"));
      })
      .catch((e) => {
        errorStatusHandle(e.response);
        const errors = e?.response?.data.message?? {};
        setErrors(Object.keys(errors));
        dispatch(setAlertError(Object.values(errors)));
        setInspectionStatus({});
        dispatch(clearComponentLoading("inspection_status_table"));
      });
    }
  }, [params, dispatch, dates]);

  return {
    dates,
    inspectionStatus,
    setInspectionStatus,
    params,
    setParams,
    errors,
  };
};
